<template>
  <div class="contMain" v-if="inited">
    <a-layout id="components-layout-demo-side" style="min-height: 100vh">

      <a-layout-sider>
        <div class="logo">
          <img style="height: 100%" src="../assets/logo.png"/>
          <span v-if="!collapsed" style="font-size: 12px;color: #fff;font-weight: bold;">数智出版云平台</span>
        </div>
        <a-menu
            :default-open-keys="openKeys"
            @click="menuClick" theme="dark" mode="inline">

          <template v-for="(item) in inLayoutRoute">
            <template v-if="item.isMenu">
              <a-sub-menu v-if="item.children && item.children.length > 0" :key="item.name">
                <template v-slot:title>
                  <span><span>{{ (item.meta || {}).title }}</span></span>
                </template>
                <template v-for="(menu) in item.children">
                  <a-menu-item v-if="menu.isMenu && subMenuVisible(menu)" :key="menu.name">
                    {{ menu.meta.title }}
                  </a-menu-item>
                </template>
              </a-sub-menu>
            </template>


          </template>

        </a-menu>
      </a-layout-sider>

      <a-layout>
        <a-layout-header style="background: #fff; padding: 0">
          <div class="fr portrait">
            <a-dropdown>
              <span class="photoBox">
                <span class='userName'>{{user.name}}（{{ user.company.name }}）</span>
              </span>
              <template v-slot:overlay>
                <a-menu>
                  <a-menu-item @click="loginOut">
                    <a href="javascript:;">退出登陆</a>
                  </a-menu-item>
                  <a-menu-item
                    v-if="hasSwitchableCompanies"
                    @click="openCompanySwitchModal"
                  >
                    <span>切换主体</span>
                  </a-menu-item>
                </a-menu>
              </template>
            </a-dropdown>
          </div>
        </a-layout-header>
        <a-layout-content style="margin: 0 16px;height: calc(100vh - 133px);overflow-x: hidden;overflow-y: auto">
          <a-breadcrumb style="margin: 16px 0">
            <a-breadcrumb-item v-for="(item,key) in navLabel" :key="key">{{item}}</a-breadcrumb-item>
          </a-breadcrumb>
          <div class="conent">
            <router-view />
          </div>
        </a-layout-content>
      </a-layout>
    </a-layout>

    <a-modal
      title="切换主体"
      :visible="companySwitchModalVisible"
      :footer="null"
      destroy-on-close
      @cancel="closeCompanySwitchModal"
    >
      <a-spin :spinning="companySwitchLoading">
        <a-list
          :data-source="companyListForSwitch"
          item-layout="horizontal"
          :locale="{ emptyText: '暂无可切换主体' }"
        >
          <a-list-item
            slot="renderItem"
            slot-scope="item"
            class="company-switch-item"
            @click.native="onSelectCompany(item)"
          >
            <a-list-item-meta>
              <template slot="title">
                <span>{{ item.name || item.abbr || '—' }}</span>
                <a-tag v-if="isCurrentCompany(item)" color="blue" style="margin-left: 8px">
                  当前
                </a-tag>
              </template>
              <template v-if="item.abbr && item.name" slot="description">
                {{ item.abbr }}
              </template>
            </a-list-item-meta>
          </a-list-item>
        </a-list>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>


import {
  inLayoutRoute
} from '../router/index'
import {getArrayValue, searchTree} from '../utils/index'
import {mapActions, mapState} from "vuex";

export default {
  name: "layout",

  data() {
    return {
      inited: false,
      inLayoutRoute,
      collapsed: false,
      selectedKeys: [inLayoutRoute[0].name],
      openKeys: [],
      navLabel: [],
      companySwitchModalVisible: false,
      companySwitchLoading: false,
    }
  },
  computed: {
    ...mapState({
      user: state => state.security.user
    }),
    hasSwitchableCompanies() {
      const list = this.user && this.user.companyList
      return Array.isArray(list) && list.length > 0
    },
    companyListForSwitch() {
      const list = this.user && this.user.companyList
      return Array.isArray(list) ? list : []
    }
  },
  async mounted() {
    try{
      let resp = this.user
      if(!this.user || !this.user.id){
        resp = await this.$store.dispatch('security/current')
      }
      console.log('Layout')
      console.log(resp)
      let router = []
      for(let i = 0; i < inLayoutRoute.length; i++) {
        const item = inLayoutRoute[i]
        if(!item.meta || !item.meta.permission) {
          router.push(item)
          continue
        }
        if(this.$hasPermissions(item.meta.permission)) {
          router.push(item)
          continue
        }
        // 父级无权限时：若任一子菜单有权限，仍展示该分组（如仅拥有角色权限时可见「系统设置」）
        if (item.children && item.children.length) {
          const anyChildVisible = item.children.some((child) => {
            const p = child.meta && child.meta.permission
            if (!p) {
              return true
            }
            return this.$hasPermissions(p)
          })
          if (anyChildVisible) {
            router.push(item)
          }
        }
      }
      this.inLayoutRoute = router
    }catch(e){
    }
    this.inited = true
  },
  methods: {
    subMenuVisible(menu) {
      const p = (menu.meta && menu.meta.permission) || (menu.permission)
      if (!p) {
        return true
      }
      return this.$hasPermissions(p)
    },
    loginOut(){
      this.$confirm({
        title: '退出提示?',
        content: '确定退出当前账号吗？',
        onOk:()=> {
          sessionStorage.clear();
          this.logout()
          this.$router.replace('/login')
        }
      });
    },
    openCompanySwitchModal() {
      if (!this.hasSwitchableCompanies) {
        this.$message.warning('无可切换主体')
        return
      }
      this.companySwitchModalVisible = true
    },
    closeCompanySwitchModal() {
      this.companySwitchModalVisible = false
    },
    isCurrentCompany(row) {
      const curId = this.user.company && this.user.company.id
      if (curId != null && row.id === curId) {
        return true
      }
      // return row.currentLogin === 1
    },
    async onSelectCompany(row) {
      const curId = this.user.company && this.user.company.id
      if (curId != null && row.id === curId) {
        this.$message.info('已是当前主体')
        return
      }
      this.companySwitchLoading = true
      try {
        await this.$store.dispatch('security/switchLoginCompany', row.id)
        this.$message.success('切换成功')
        window.location.reload()
      } catch (e) {
        // 错误已在 store 中提示
      } finally {
        this.companySwitchLoading = false
      }
    },
    menuClick(e) {
      console.log(e,'点击了')
      let menuList = getArrayValue(inLayoutRoute, 'name', e.key)
      this.navLabel = [menuList.meta.title]
      this.$router.replace({path: menuList.path})
    },
    ...mapActions(['logout'])
  }
}

</script>

<style scoped lang="less">
.portrait{
  padding-right: 16px;
  .photoBox{
    cursor: pointer;
  }
}
#components-layout-demo-side .logo {
  height: 32px;
  margin: 16px;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.conent{
  background: white;
  box-sizing: border-box;
  padding: 12px;
}
.company-switch-item {
  cursor: pointer;
}
</style>
